import type { TaxIncentiveJurisdiction } from "types/tax-incentive-catalog";
import { mapJurisdictionToStructuredProgram } from "./taxIncentiveCatalog.mapper";
import { StructuredTaxIncentiveProgram } from "./taxIncentiveCatalog.types";

let cachedPrograms: Record<string, StructuredTaxIncentiveProgram> | null = null;

export function hydrateStructuredTaxIncentiveCatalog(
  jurisdictions: TaxIncentiveJurisdiction[]
): void {
  cachedPrograms = Object.fromEntries(
    jurisdictions.map((jurisdiction) => [
      jurisdiction.jurisdiction_name,
      mapJurisdictionToStructuredProgram(jurisdiction),
    ])
  );
}

export function buildStructuredTaxIncentiveCatalog(): Record<
  string,
  StructuredTaxIncentiveProgram
> {
  return cachedPrograms ?? {};
}

export function getStructuredTaxIncentiveProgram(
  jurisdictionName: string
): StructuredTaxIncentiveProgram | undefined {
  return buildStructuredTaxIncentiveCatalog()[jurisdictionName];
}

export function getActiveStructuredTaxIncentivePrograms(): StructuredTaxIncentiveProgram[] {
  return Object.values(buildStructuredTaxIncentiveCatalog()).filter((program) => program.isActive);
}

export function resetStructuredTaxIncentiveCatalogCache(): void {
  cachedPrograms = null;
}
